(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jmt-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__jmtColl) return;
      root.__jmtColl = true;
      var form = root.querySelector('[data-coll-form]');
      if (!form) return;
      var toggle = form.querySelector('[data-coll-toggle]');
      var panel = form.querySelector('[data-coll-panel]');
      var sort = form.querySelector('[data-coll-sort]');

      if (toggle && panel) {
        if (form.querySelector('.jmt-coll__chips')) { /* keep panel closed, chips show what is active */ }
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
      }

      function dropEmpty() {
        var inputs = form.querySelectorAll('input[type=number]');
        for (var i = 0; i < inputs.length; i++) { if (inputs[i].value === '') inputs[i].disabled = true; }
      }

      form.addEventListener('submit', dropEmpty);
      if (sort) sort.addEventListener('change', function () { dropEmpty(); form.submit(); });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-jmt-coll]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jmt-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__jmtPdp) return;
      root.__jmtPdp = true;

      var dataEl = root.querySelector('[data-pdp-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var idInput = root.querySelector('[data-pdp-id]');
      var addBtn = root.querySelector('[data-pdp-add]');
      var buyNow = root.querySelector('[data-pdp-buynow]');
      var priceEl = root.querySelector('[data-pdp-price]');
      var track = root.querySelector('[data-pdp-track]');
      var count = root.querySelector('[data-pdp-count]');
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');
      var slides = root.querySelectorAll('.jmt-pdp__slide');
      var qty = root.querySelector('[data-pdp-qty-input]');
      var sticky = root.querySelector('[data-pdp-sticky]');
      var stickyBtn = root.querySelector('[data-pdp-sticky-add]');
      var stickyPrice = root.querySelector('[data-pdp-sticky-price]');
      var stickyLabel = root.getAttribute('data-sticky-label') || 'Add to cart';

      /* colour row: scroll the chosen colour into view when the page opens */
      var colourRow = root.querySelector('.jmt-pdp__swatches');
      var colourNow = colourRow && colourRow.querySelector('.is-current');
      if (colourRow && colourNow) colourRow.scrollLeft = Math.max(0, colourNow.parentNode.offsetLeft - (colourRow.clientWidth - colourNow.offsetWidth) / 2);

      function goTo(i, smooth) {
        if (!track || !slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }

      function syncGallery() {
        if (!track || !track.clientWidth) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        for (var t = 0; t < thumbs.length; t++) {
          if (t === i) thumbs[t].setAttribute('aria-current', 'true');
          else thumbs[t].removeAttribute('aria-current');
        }
        /* pause a video once it is swiped out of view */
        for (var s = 0; s < slides.length; s++) {
          if (s !== i) {
            var vid = slides[s].querySelector('video');
            if (vid && !vid.paused) vid.pause();
          }
        }
      }

      if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(syncGallery); }, { passive: true });
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].addEventListener('click', function (e) { goTo(Number(e.currentTarget.getAttribute('data-pdp-thumb')), true); });
      }

      function selectedOptions() {
        var chosen = [];
        var inputs = root.querySelectorAll('[data-pdp-option]:checked');
        for (var i = 0; i < inputs.length; i++) chosen[Number(inputs[i].getAttribute('data-pdp-option'))] = inputs[i].value;
        return chosen;
      }

      function findVariant(chosen) {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < chosen.length; j++) { if (variants[i].options[j] !== chosen[j]) { ok = false; break; } }
          if (ok) return variants[i];
        }
        return null;
      }

      function priceHtml(v) {
        var html = '<span class="jmt-price"><span class="jmt-price__now">' + v.price + '</span>';
        if (v.onSale) html += '<s class="jmt-price__was">' + v.compare + '</s><span class="jmt-price__off">-' + v.off + '%</span>';
        return html + '</span>';
      }

      function setButtons(label, disabled) {
        addBtn.disabled = disabled;
        addBtn.textContent = label;
        if (buyNow) buyNow.disabled = disabled;
        if (stickyBtn) { stickyBtn.disabled = disabled; stickyBtn.textContent = disabled ? label : stickyLabel; }
      }

      function update() {
        var chosen = selectedOptions();
        for (var i = 0; i < chosen.length; i++) {
          var label = root.querySelector('[data-pdp-selected="' + i + '"]');
          if (label) label.textContent = chosen[i];
        }
        var v = findVariant(chosen);
        if (!v) {
          setButtons('Unavailable', true);
          return;
        }
        idInput.value = v.id;
        priceEl.innerHTML = priceHtml(v);
        if (stickyPrice) stickyPrice.textContent = v.price;
        setButtons(v.available ? 'Add to cart' : 'Sold out', !v.available);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (v.media) {
          for (var s = 0; s < slides.length; s++) {
            if (Number(slides[s].getAttribute('data-media-id')) === v.media) { goTo(s, false); break; }
          }
        }
      }

      root.addEventListener('change', function (e) { if (e.target.matches('[data-pdp-option]')) update(); });

      root.addEventListener('click', function (e) {
        var step = e.target.closest('[data-pdp-qty]');
        if (!step || !qty) return;
        var next = (parseInt(qty.value, 10) || 1) + Number(step.getAttribute('data-pdp-qty'));
        qty.value = Math.max(1, next);
      });
      if (qty && qty.type === 'number') qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

      /* Buy now: add this variant to the cart, then go straight to checkout. Falls back to a normal add to cart if that fails. */
      if (buyNow) {
        buyNow.addEventListener('click', function () {
          if (buyNow.disabled) return;
          var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
          buyNow.disabled = true;
          fetch(buyNow.getAttribute('data-cart-add'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: q }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          }).catch(function () {
            buyNow.disabled = false;
            var form = addBtn.form;
            if (form && form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
          });
        });
      }

      /* Sticky bar: shows after the main buy row scrolls above the screen, hides again near the footer. Its button is Buy now when that is enabled. */
      if (sticky && stickyBtn) {
        var buyRow = root.querySelector('[data-pdp-buy]');
        var past = false;
        var footerIn = false;
        var paintSticky = function () {
          var on = past && !footerIn;
          sticky.classList.toggle('is-visible', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          stickyBtn.tabIndex = on ? 0 : -1;
        };
        stickyBtn.addEventListener('click', function () {
          if (buyNow) { buyNow.click(); return; }
          var form = addBtn.form;
          if (!form) return;
          if (form.requestSubmit) form.requestSubmit(addBtn);
          else addBtn.click();
        });
        if ('IntersectionObserver' in window) {
          if (buyRow) {
            new IntersectionObserver(function (entries) {
              var en = entries[0];
              past = !en.isIntersecting && en.boundingClientRect.top < 0;
              paintSticky();
            }, { threshold: 0 }).observe(buyRow);
          }
          var footer = document.querySelector('footer');
          if (footer) {
            new IntersectionObserver(function (entries) {
              footerIn = entries[0].isIntersecting;
              paintSticky();
            }, { threshold: 0 }).observe(footer);
          }
        }
      }

      /* Pincode check: one slim row. The result line appears under it and hides itself once the shopper scrolls on. It shows an estimate from the settings; it does not check courier coverage. */
      var pinForm = root.querySelector('[data-pdp-pin-form]');
      if (pinForm) {
        var box = root.querySelector('[data-pdp-delivery]');
        var pinInput = pinForm.querySelector('[data-pdp-pin]');
        var pinMsg = root.querySelector('[data-pdp-pin-msg]');
        var dmin = parseInt(box.getAttribute('data-min'), 10) || 3;
        var dmax = parseInt(box.getAttribute('data-max'), 10) || dmin + 1;
        var cod = box.getAttribute('data-cod') === 'true';
        var shownAt = 0;
        var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
        var hideMsg = function () { pinMsg.hidden = true; };
        var showMsg = function () { pinMsg.hidden = false; shownAt = window.pageYOffset; };
        var showPin = function (pin) {
          pinMsg.textContent = '';
          if (!/^[1-9][0-9]{5}$/.test(pin)) {
            pinMsg.className = 'jmt-pdp__pin-msg is-error';
            pinMsg.textContent = 'Please enter a valid 6-digit pincode.';
            showMsg();
            return false;
          }
          var a = new Date(); a.setDate(a.getDate() + dmin);
          var b = new Date(); b.setDate(b.getDate() + dmax);
          pinMsg.className = 'jmt-pdp__pin-msg';
          var strong = document.createElement('strong');
          strong.textContent = 'Est. delivery ' + fmt(a) + ' – ' + fmt(b);
          pinMsg.appendChild(strong);
          if (cod) pinMsg.appendChild(document.createTextNode(' · COD available'));
          showMsg();
          return true;
        };
        try {
          var saved = window.localStorage.getItem('jmt-pincode');
          if (saved && /^[1-9][0-9]{5}$/.test(saved)) pinInput.value = saved;
        } catch (e) {}
        pinInput.addEventListener('input', function () { pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6); });
        pinForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var pin = pinInput.value.trim();
          if (showPin(pin)) { try { window.localStorage.setItem('jmt-pincode', pin); } catch (err) {} }
        });
        window.addEventListener('scroll', function () {
          if (!pinMsg.hidden && Math.abs(window.pageYOffset - shownAt) > 90) hideMsg();
        }, { passive: true });
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-jmt-pdp]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jmt-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__jmtRv) return;
      root.__jmtRv = true;
      var app = root.querySelector('[data-rv-app]');
      var lb = root.querySelector('[data-rv-lb]');
      var lbImg = root.querySelector('[data-rv-img]');
      var prevBtn = root.querySelector('[data-rv-prev]');
      var nextBtn = root.querySelector('[data-rv-next]');
      var group = [], idx = 0;

      /* Write a review: opens Judge.me's own form by pressing its (hidden) button. */
      var writeBtn = root.querySelector('[data-rv-write]');
      function findWrite() {
        if (!app) return null;
        var els = app.querySelectorAll('a, button, [role="button"]');
        for (var i = 0; i < els.length; i++) {
          var t = (els[i].textContent || '').toLowerCase();
          if (t.indexOf('write a review') > -1 || t.indexOf('write review') > -1) return els[i];
        }
        return app.querySelector('.jdgm-write-rev-link');
      }
      if (writeBtn) writeBtn.addEventListener('click', function () {
        var el = findWrite();
        if (el) { el.click(); return; }
        if (app) { app.classList.add('is-open'); app.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });

      var allBtn = root.querySelector('[data-rv-all]');
      if (allBtn) allBtn.addEventListener('click', function () {
        var open = app.classList.toggle('is-open');
        allBtn.textContent = open ? 'Hide full list' : allBtn.getAttribute('data-label') || allBtn.textContent;
        if (open) app.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      if (allBtn) allBtn.setAttribute('data-label', allBtn.textContent);

      /* Read more / show less */
      root.addEventListener('click', function (e) {
        var more = e.target.closest('[data-rv-more]');
        if (more) {
          var tx = more.parentNode.querySelector('[data-rv-text]');
          var open = tx.classList.toggle('is-open');
          more.textContent = open ? 'Show less' : 'Read more';
          return;
        }
        var th = e.target.closest('.jmt-rv__th');
        if (th) {
          var g = th.getAttribute('data-group');
          var nodes = root.querySelectorAll('.jmt-rv__th[data-group="' + g + '"]');
          group = [];
          for (var i = 0; i < nodes.length; i++) { group.push(nodes[i].getAttribute('data-full')); if (nodes[i] === th) idx = i; }
          show();
        }
      });

      /* Filters */
      var chips = root.querySelectorAll('[data-rv-filter]');
      var none = root.querySelector('[data-rv-none]');
      for (var c = 0; c < chips.length; c++) {
        chips[c].addEventListener('click', function (e) {
          var f = e.currentTarget.getAttribute('data-rv-filter');
          for (var k = 0; k < chips.length; k++) chips[k].setAttribute('aria-pressed', chips[k] === e.currentTarget ? 'true' : 'false');
          var revs = root.querySelectorAll('.jmt-rv__rev');
          var shown = 0;
          for (var r = 0; r < revs.length; r++) {
            var ok = f === 'all' || revs[r].getAttribute('data-photos') === '1';
            revs[r].hidden = !ok;
            if (ok) shown++;
          }
          if (none) none.hidden = shown > 0;
        });
      }

      /* Photo viewer */
      function show() {
        if (!lb || !group.length) return;
        lbImg.src = group[idx];
        prevBtn.hidden = nextBtn.hidden = group.length < 2;
        lb.hidden = false;
      }
      function hide() { if (lb) { lb.hidden = true; lbImg.src = ''; } }
      function step(d) { idx = (idx + d + group.length) % group.length; show(); }
      if (lb) {
        root.querySelector('[data-rv-close]').addEventListener('click', hide);
        prevBtn.addEventListener('click', function () { step(-1); });
        nextBtn.addEventListener('click', function () { step(1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) hide(); });
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') hide();
          if (e.key === 'ArrowLeft') step(-1);
          if (e.key === 'ArrowRight') step(1);
        });
      }
    }
    function initAll() {
      var roots = document.querySelectorAll('[data-jmt-reviews]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jmt-trust-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTrustStrip(root) {
      if (root.__jmtTband) return;
      var vp = root.querySelector('[data-tband-viewport]');
      var groups = root.querySelectorAll('.jmt-tband__group');
      if (!vp || groups.length < 4) return;
      root.__jmtTband = true;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var speed = parseFloat(root.getAttribute('data-speed')) || 46;
      var pos = 0;
      var last = 0;
      var resumeAt = 0;
      var dirty = false;
      var visible = true;

      function loopWidth() { return groups[0].offsetWidth * 2; }

      function wrap() {
        var w = loopWidth();
        if (!w) return;
        if (vp.scrollLeft >= w) { vp.scrollLeft -= w; pos = vp.scrollLeft; }
        else if (vp.scrollLeft <= 0) { vp.scrollLeft += w; pos = vp.scrollLeft; }
      }

      function hold() { resumeAt = Infinity; dirty = true; }
      function release(delay) { resumeAt = performance.now() + delay; dirty = true; }

      vp.addEventListener('touchstart', hold, { passive: true });
      vp.addEventListener('touchend', function () { release(2200); }, { passive: true });
      vp.addEventListener('touchcancel', function () { release(2200); }, { passive: true });
      vp.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') hold(); }, { passive: true });
      window.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse' && resumeAt === Infinity && !root.matches(':hover')) release(800); }, { passive: true });
      vp.addEventListener('mouseenter', hold);
      vp.addEventListener('mouseleave', function () { release(800); });
      vp.addEventListener('wheel', function () { release(2200); }, { passive: true });
      vp.addEventListener('focusin', hold);
      vp.addEventListener('focusout', function () { release(800); });
      vp.addEventListener('scroll', function () { if (resumeAt !== 0 && performance.now() < resumeAt) wrap(); }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0 }).observe(root);
      }

      vp.scrollLeft = groups[0].offsetWidth;
      pos = vp.scrollLeft;

      function frame(now) {
        requestAnimationFrame(frame);
        var dt = Math.min((now - last) / 1000, 0.1);
        last = now;
        if (reduce.matches || !visible || document.hidden || now < resumeAt) return;
        if (dirty) { pos = vp.scrollLeft; dirty = false; }
        pos += speed * dt;
        var w = loopWidth();
        if (w && pos >= w) pos -= w;
        vp.scrollLeft = Math.round(pos);
      }
      requestAnimationFrame(function (t) { last = t; frame(t); });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-jmt-tband]');
      for (var i = 0; i < roots.length; i++) initTrustStrip(roots[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
